module.exports = __webpack_public_path__ + "img/28.b8226c97.png";